import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';

export const Group = styled.div`
  width: 100%;
  max-width: 662px;
  margin: 0 auto;
  margin-bottom: 24px;
  ${mobile_xl(css`
    margin-bottom: 80px;
  `)}
`;
export const PersonalHeader = styled.div`
  ${mobile_xl(css`
    display: flex;
    align-items: center;
    gap: 24px;
  `)}
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 0 14px;
  width: 100%;
  max-width: 662px;
  margin: 0 auto;
  align-items: center;
`;

export const PersonalText = styled.div`
  ${Typography.heading_lg}
  color: var(--text-primary);
`;

export const Content = styled.div`
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
  ${mobile_xl(css`
    margin-top: 8px;
  `)}
`;

export const Data = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 0.5px solid var(--border-primary);
  :last-child {
    border-bottom: none;
  }

  :hover {
    cursor: pointer;
  }
`;

export const LeftSection = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const ActiveTag = styled.div`
  border: 1px solid var(--brand-secondary);
  background: var(--brand-secondary);
  border-radius: var(--border-radius-6);
  padding: 2px 4px;
  color: var(--brand-primary);
  ${Typography.body_sm}
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const Image = styled.img`
  width: 32px;
  height: 32px;
  border-radius: var(--border-radius-8);
`;

export const Title = styled.h3`
  ${Typography.body_lg_medium}
  color: var(--text-primary);
  margin: 0;
`;

export const Description = styled.p`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: 0;
`;

export const Heading = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
`;

export const HeadingTitle = styled.p`
  ${Typography.body_lg_medium}
  color: var(--text-secondary);
  margin: 0;
  padding: 2px 4px;
`;

export const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const UserDetails = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
`;

export const UserSubDetails = styled.div`
  display: flex;
  gap: 12px;
`;

export const UserImage = styled.img`
  width: 42px;
  height: 42px;
  border-radius: var(--border-radius-8);
  padding-top: 1px;
`;

export const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  h1 {
    ${Typography.heading_lg}
    color: var(--text-primary);
    margin: 0;
  }
`;

export const AIAgentsDetailsSection = styled.div`
  display: flex;
  flex-direction: column;
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-8);
  background: var(--background-primary);
`;

export const Box = styled.div`
  padding: 12px 16px;
  border-bottom: 0.5px solid var(--border-primary);
  :last-child {
    border-bottom: none;
  }
  h2 {
    ${Typography.body_lg_semibold}
    color: var(--text-primary);
    margin: 0 0 6px;
  }
  h3 {
    ${Typography.body_md_medium}
    color: var(--text-primary);
    margin: 8px 0 6px;
    &:first-of-type {
      margin-top: 0;
    }
  }
  p {
    ${Typography.body_md}
    color: var(--text-secondary);
    margin: 0;
  }
  ul {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin: 0;
    padding-left: 16px;
    li {
      ${Typography.body_md}
      color: var(--text-secondary);
      margin: 0;
    }
  }
`;

export const TagDiv = styled.div`
  .deactivate-button {
    display: none;
  }
  &:hover {
    .active-tag {
      display: none;
    }
    .deactivate-button {
      display: flex;
    }
  }
`;
